import type { DeviceManifest } from '@rapoo/device-sdk'
import { mouseMacro, mousePerfCap } from './generate/capabilityPresets'

/**
 * VT2 ULTRA V2 设备清单。
 * 仅提供识别与现有 Web 所需的静态声明，不包含任何业务逻辑。
 */
const rapooVT2UltraV2: DeviceManifest = {
  channel: ['china_game'],
  model: 'VT2 ULTRA V2',
  mainControl: 'VT2 ULTRA V2',
  dongleModel: 'Dongle_Telink3228C',
  type: 'mouse',
  version: '1.0.0',
  hardware: {
    // 用户实机确认：有线鼠标为 24AE/4B00，无线接收器为 24AE/1B00。(不一定 未真正去人 看实机)
    vendorId: 0x24ae,
    // productId: [0x4b00, 0x1b00],
    productId: [0x4672, 0x1472],
    // currentPid: 0x4b00,
    currentPid: 0x4672,
    transport: 'HID',
    filters: [
      {
        usagePage: 0xff1c,
        usage: 0x92,
        description: 'Telink AP mouse control interface',
        type: 'default',
      },
      {
        // 配对结果在接收器 IF1 Consumer Control（Windows「HID-compliant consumer control」）。
        // Report ID 0x03 的 03 FF FD/FF/FE 在此接口上报，不在控制口 FF1C:92。
        usagePage: 0x0c,
        usage: 0x01,
        description: 'Telink dongle USB pairing result interface (Consumer Control)',
        type: 'pairing',
      },
      {
        // 原厂 USB OTA 工具状态栏（有线 24AE/4B00）：ReportID=05，IID/UsagePage=FFEF，Usage=00。
        // Report ID 由 Bootloader 协议使用，不参与接口枚举。
        usagePage: 0xffef,
        usage: 0x00,
        description: 'Telink USB Bootloader OTA interface',
        type: 'update',
      },
    ],
  },
  driver: 'Telink3228C_Mouse',
  MCU: 'TL3228C',
  ui: {
    assetsDir: 'manifests/VT2 ULTRA V2',
    colors: {
      series: [
        {
          name: 'common.products.VT2_ULTRA_V2.Metallic_Crimson',
          value: '#914040',
          key: 'Metallic_Crimson',
        },
      ],
      current: 'Metallic_Crimson',
    },
    icon: 'Hardware-Wireframe-Mouse',
    overview: true,
  },
  capabilities: [
    {
      type: 'config',
      config: {
        // V0106 名称区每个 profile 16 字节（UTF-8），与 SDK encodeVisionApProfileName 上限一致。
        maxNameLen: 0x10,
        maxConfig: 8,
      },
    },
    {
      type: 'mouseKeys',
      config: {
        hiddenBasicKeys: ['Dongle cycle'],
        macroCoordinateRange: {
          min: -255,
          max: 255,
        },
      },
    },
    {
      type: 'pairing',
      config: {
        hideStep2: true,
        hideInstruction: true,
      },
    },
    {
      type: 'parameters',
      config: {
        liftoffHeight: [0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7],
        sleepTimeRange: { min: 5, max: 120 },
      },
    },
    {
      type: 'dpi',
      config: {
        min: 1,
        max: 40000,
        step: 1,
      },
    },
    mouseMacro,
    mousePerfCap({ tier: 'retail', sensorScanRateLabel: '13K' }),
  ],
  layout: {
    keys: [
      [
        {
          key: 0,
          keywords: '左击',
          x: -25,
          y: 50,
          alignLeft: false,
          url: 'mouse left',
        },
        {
          key: 1,
          keywords: '中键',
          x: 240,
          y: 52,
          alignLeft: true,
          url: 'roller middle',
        },
        {
          key: 2,
          keywords: '右击',
          x: 240,
          y: 156,
          alignLeft: true,
          url: 'mouse right',
        },
        {
          key: 5,
          keywords: '右侧',
          x: -25,
          y: 132,
          alignLeft: false,
          url: 'mouse forward',
        },
        {
          key: 6,
          keywords: '左侧',
          x: -25,
          y: 195,
          alignLeft: false,
          url: 'mouse back',
        },
        {
          key: 9,
          keywords: '上滚',
          x: 240,
          y: 0,
          alignLeft: true,
          url: 'roller up',
        },
        {
          key: 10,
          keywords: '下滚',
          x: 240,
          y: 104,
          alignLeft: true,
          url: 'roller down',
        },
        {
          key: 13,
          keywords: 'DIY',
          x: 655,
          y: 118,
          alignLeft: true,
          url: 'diy',
        },
      ],
    ],
  },
}

export default rapooVT2UltraV2
